import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_USER_AUTH, SHOW_LOADING_SPINNER } from '../actions/authActionCreator';
import { TAction } from '../actions/types/action';
import {
  SET_CHARACTER_CUSTOMIZATION_PARAMS,
  updateAuthClaimedCharacters
} from '../../../../../shared/frontend/scripts/actions/userSettingsActionCreator';

export default function authReducer(state: any = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_USER_AUTH: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isLoaded: true
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        ...(action.payload
          ? {
              isLoading: true,
              isLoaded: false
            }
          : {
              isLoading: false
            })
      };
    }
    case SET_CHARACTER_CUSTOMIZATION_PARAMS: {
      return updateAuthClaimedCharacters(state, action);
    }
    case LOCATION_CHANGE: {
      return state; // keep the initial state that was loaded
    }
    default:
      return state;
  }
}
